/**
 *  @since 0.0.1
 */
export const assignFunction = (ab, c) => {
    // tslint:disable-next-line: no-unnecessary-callback-wrapper
    const newF = ((...x) => ab(...x)); // force the creation of a new function to prevent mutation on the original
    return Object.assign(newF, c);
};
/**
 *  @since 0.0.1
 */
export const assignCallable = (F, d) => assignFunction(F, Object.assign({}, F, d));
/**
 *  @since 0.0.1
 */
// tslint:disable-next-line: no-unnecessary-callback-wrapper
export const wrapFun = (g) => ((x) => g(x)); // force the creation of a new function to prevent mutation on the original
/**
 * Fake inhabitation of types
 */
/**
 *  @since 0.0.1
 */
export const inhabitTypes = (t) => t;
